export const environment = {
  production: false,
  graphqlUri: '/graphql',
  csvUrl: '/export/cobertura.csv',
};
